module.exports = __webpack_public_path__ + "img/Villa_Borna_34.de09a387.jpg";